import api from '@/api';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { ON_THE_WHOLE_STRATUM, SEPARATE_STRATUM, WITHOUT_STRATUM } from './additional-stratums';
import { isEmpty, debounce } from 'lodash';

dayjs.extend(customParseFormat);

export const gdis = {
    name: 'gdis',
    state: {
        data: null,
        isFetching: false,
    },
    reducers: {
        setGdisData(state, payload) {
            return { ...state, data: payload };
        },
        setIsFetching(state, payload) {
            return { ...state, isFetching: payload };
        },
    },
    effects: dispatch => ({
        fetchData: debounce(async function (payload) {
            this.setIsFetching(true);
            try {
                const result = await api.productionInjection.fetchDataGdis({ body: payload });
                this.setGdisData(result);
            } catch (error) {
                console.error('fetchData - gdis');
                console.error(error);
            }
            this.setIsFetching(false);
        }, 300),
        async prepareDataForSettings(payload) {
            const generateData = gdisData => {
                const result = {};
                if (!gdisData) return [];
                Object.values(gdisData).forEach((gdis, idxParent) => {
                    Object.entries(gdis).forEach(([key, item], idx) => {
                        const date = dayjs(item.date).format('DD.MM.YYYY');
                        result[key] = {
                            key,
                            entityKey: `gdis_${idxParent}_${idx}`,
                            type: 'gdis',
                            date: date,
                            parameters: null,
                            params: item.params,
                            points: [dayjs(item.date).format('MM.YYYY')],
                            color: '#FC8E28',
                            comment: '',
                            group: { key: `gdis_${idxParent}_${idx}`, title: `${item.stratumTitle} ${item.shortName}` },
                            title: `${item.stratumTitle} ${item.shortName}`,
                        };
                    });
                });
                return result;
            };
            const generateDefaultSelectedGdis = gdisData => {
                const result = [];
                if (!gdisData) return [];
                Object.values(gdisData).forEach((gdis, idxParent) => {
                    Object.entries(gdis).forEach(([key, item], idx) => {
                        const date = dayjs(item.date).format('DD.MM.YYYY');
                        result.push({
                            key,
                            isVisible: true,
                            entityKey: `gdis_${idxParent}_${idx}`,
                            date: date,
                            parameters: null,
                            params: item.params,
                            points: [dayjs(item.date).format('MM.YYYY')],
                            color: '#FC8E28',
                            comment: '',
                            group: { key: `gdis_${idxParent}_${idx}`, title: `${item.stratumTitle} ${item.shortName}` },
                            title: `${item.stratumTitle} ${item.shortName}`,
                        });
                    });
                });
                return result;
            };
            const data = generateData(payload);
            const selectedRows = generateDefaultSelectedGdis(payload);
            // Исследования
            const gdis = {
                gdis: {
                    key: 'gdis',
                    data,
                    selectedRows,
                    title: 'Исследования',
                },
            };
            return gdis;
        },
    }),
    selectors: (slice, createSelector) => ({
        filteredGDISData() {
            return createSelector(
                rootState => rootState.chartsWidget.activeStratums,
                rootState => rootState.gdis.data,
                (activeStratums, gdis) => {
                    if (!isEmpty(activeStratums) && !isEmpty(gdis)) {
                        const filteredGDISData = {};

                        for (const outerKey in gdis) {
                            const group = gdis[outerKey];
                            const filteredGroup = {};

                            for (const itemKey in group) {
                                const item = group[itemKey];
                                const stratumId = item.stratumId;
                                item.params = item.params.map(obj =>
                                    Object.fromEntries(
                                        Object.entries(obj).map(([key, value]) => [key, value === null ? '' : value]),
                                    ),
                                );

                                if (
                                    !(stratumId in activeStratums) ||
                                    activeStratums[stratumId] ||
                                    activeStratums[ON_THE_WHOLE_STRATUM.id]
                                ) {
                                    filteredGroup[itemKey] = item;
                                }
                            }

                            if (Object.keys(filteredGroup).length > 0) {
                                filteredGDISData[outerKey] = filteredGroup;
                            }
                        }

                        return filteredGDISData;
                    }

                    return {};
                },
            );
        },
    }),
};
